import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import Skeleton from 'react-loading-skeleton';
import drugSearchAnalyticService from '../../../services/drug-search-analytics.service';
import { capitalizeFirstLetter } from '../../../utils/textFormatUtils';

const MostSearchedDrugs = ({ filters }) => {
  const [mostSearchedDrugs, setMostSearchedDrugs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMostSearchedDrugs = async () => {
      setError(false);
      setLoading(true);
      try {
        setLoading(true);
        const data = await drugSearchAnalyticService.getMostSearchedDrugs({
          ...filters,
        });
        setMostSearchedDrugs(data?.top_10_drugs || []);
      } catch (err) {
        console.error('Error fetching top searched drugs:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchMostSearchedDrugs();
  }, [filters]);

  if (loading) {
    return (
      <div className="mb-3">
        <Skeleton
          height={20}
          width={220}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
        />
        <Skeleton
          height={14}
          width={160}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
          style={{ marginTop: 8 }}
        />
        <Skeleton height={280} baseColor="#dee2e6" highlightColor="#e9ecef" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-danger text-center fw-semibold">
        Failed to load most searched drug details.
      </div>
    );
  }

  if (mostSearchedDrugs.length === 0) {
    return (
      <div className="text-muted text-center fw-semibold">
        No data available for most searched drugs.
      </div>
    );
  }

  const chartOptions = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 4,
        distributed: true,
        barHeight: '45%',
      },
    },
    legend: {
      show: false,
    },
    dataLabels: { enabled: false },
    tooltip: {
      followCursor: true,
      y: { formatter: (val) => `${val}` },
    },
    colors: [
      '#0f172a',
      '#1e293b',
      '#1e3a8a',
      '#1d4ed8',
      '#2563eb',
      '#3b82f6',
      '#4f8ef7',
      '#5a9df8',
      '#3f68d3',
      '#5560e9',
    ],
    xaxis: {
      categories: mostSearchedDrugs.map((drug) =>
        capitalizeFirstLetter(drug.drug_name),
      ),
      labels: { style: { colors: '#6b7280', fontSize: '12px' } },
      forceNiceScale: true,
    },
    yaxis: {
      labels: { style: { colors: '#6b7280', fontSize: '12px' } },
    },
    grid: {
      borderColor: '#e5e7eb',
      strokeDashArray: 4,
    },
  };

  const series = [
    {
      name: 'Searches',
      data: mostSearchedDrugs.map((drug) => drug.count),
    },
  ];

  return (
    <Chart options={chartOptions} series={series} type="bar" height={320} />
  );
};

export default MostSearchedDrugs;
